import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee03d7c805bcf/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee03d7c805bcf/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dee03d7c805bcf/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee03d7c805bcf/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee03d7c805bcf/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
